var map = {
	"./arrows/default": 40,
	"./arrows/default.svg": 40,
	"./arrows/down": 41,
	"./arrows/down-short": 42,
	"./arrows/down-short.svg": 42,
	"./arrows/down.svg": 41,
	"./arrows/long": 43,
	"./arrows/long-white": 44,
	"./arrows/long-white.svg": 44,
	"./arrows/long.svg": 43,
	"./arrows/right": 45,
	"./arrows/right.svg": 45,
	"./arrows/tail-spin": 46,
	"./arrows/tail-spin.svg": 46,
	"./bg/flag": 47,
	"./bg/flag.png": 47,
	"./bg/group-course": 48,
	"./bg/group-course-wave": 49,
	"./bg/group-course-wave-pink": 50,
	"./bg/group-course-wave-pink.svg": 50,
	"./bg/group-course-wave.svg": 49,
	"./bg/group-course.svg": 48,
	"./bg/headers/bamboo-forest-left": 51,
	"./bg/headers/bamboo-forest-left.png": 51,
	"./bg/headers/bamboo-forest-right": 52,
	"./bg/headers/bamboo-forest-right.png": 52,
	"./bg/headers/course": 53,
	"./bg/headers/course.jpg": 53,
	"./bg/headers/geta": 54,
	"./bg/headers/geta.png": 54,
	"./bg/headers/gold-fish": 55,
	"./bg/headers/gold-fish.png": 55,
	"./bg/headers/meal": 56,
	"./bg/headers/meal.png": 56,
	"./bg/headers/origami": 57,
	"./bg/headers/origami.png": 57,
	"./bg/headers/pricing": 58,
	"./bg/headers/pricing.png": 58,
	"./bg/headers/registration": 59,
	"./bg/headers/registration.jpg": 59,
	"./bg/headers/sumo": 60,
	"./bg/headers/sumo.png": 60,
	"./bg/headers/test": 61,
	"./bg/headers/test.jpg": 61,
	"./bg/headers/testimonials": 62,
	"./bg/headers/testimonials.svg": 62,
	"./bg/headers/video-course": 63,
	"./bg/headers/video-course.svg": 63,
	"./bg/hero": 1,
	"./bg/hero.jpg": 307,
	"./bg/hero.svg": 1,
	"./bg/mosaic": 64,
	"./bg/mosaic.png": 64,
	"./bg/mosaic/ab1": 65,
	"./bg/mosaic/ab1.jpg": 65,
	"./bg/mosaic/ab2": 66,
	"./bg/mosaic/ab2.jpg": 66,
	"./bg/mosaic/brushes": 67,
	"./bg/mosaic/brushes.svg": 67,
	"./bg/mosaic/calligraphy": 68,
	"./bg/mosaic/calligraphy.jpg": 68,
	"./bg/mosaic/camp": 69,
	"./bg/mosaic/camp-2": 70,
	"./bg/mosaic/camp-2.jpg": 70,
	"./bg/mosaic/camp.jpg": 69,
	"./bg/mosaic/circle": 71,
	"./bg/mosaic/circle.svg": 71,
	"./bg/mosaic/cloud": 72,
	"./bg/mosaic/cloud-lightblue": 73,
	"./bg/mosaic/cloud-lightblue.svg": 73,
	"./bg/mosaic/cloud-red": 74,
	"./bg/mosaic/cloud-red.svg": 74,
	"./bg/mosaic/cloud.svg": 72,
	"./bg/mosaic/concert": 75,
	"./bg/mosaic/concert.jpg": 75,
	"./bg/mosaic/conversation": 76,
	"./bg/mosaic/conversation.svg": 76,
	"./bg/mosaic/dinner": 77,
	"./bg/mosaic/dinner.jpg": 77,
	"./bg/mosaic/doki-doki": 78,
	"./bg/mosaic/doki-doki.jpg": 78,
	"./bg/mosaic/drum": 79,
	"./bg/mosaic/drum.jpg": 79,
	"./bg/mosaic/hanami": 80,
	"./bg/mosaic/hanami.jpg": 80,
	"./bg/mosaic/hidden-message": 81,
	"./bg/mosaic/hidden-message.svg": 81,
	"./bg/mosaic/kimono": 82,
	"./bg/mosaic/kimono.svg": 82,
	"./bg/mosaic/koi": 83,
	"./bg/mosaic/koi.svg": 83,
	"./bg/mosaic/lector": 84,
	"./bg/mosaic/lector.jpg": 84,
	"./bg/mosaic/lesson": 85,
	"./bg/mosaic/lesson.jpg": 85,
	"./bg/mosaic/monika": 86,
	"./bg/mosaic/monika.jpg": 86,
	"./bg/mosaic/monitor": 87,
	"./bg/mosaic/monitor.svg": 87,
	"./bg/mosaic/ninja": 88,
	"./bg/mosaic/ninja.jpg": 88,
	"./bg/mosaic/origami": 89,
	"./bg/mosaic/origami-lightblue": 90,
	"./bg/mosaic/origami-lightblue.svg": 90,
	"./bg/mosaic/origami.svg": 89,
	"./bg/mosaic/oyakata": 91,
	"./bg/mosaic/oyakata.svg": 91,
	"./bg/mosaic/pattern-arrows": 92,
	"./bg/mosaic/pattern-arrows-light-blue": 93,
	"./bg/mosaic/pattern-arrows-light-blue.svg": 93,
	"./bg/mosaic/pattern-arrows-red": 94,
	"./bg/mosaic/pattern-arrows-red.svg": 94,
	"./bg/mosaic/pattern-arrows.svg": 92,
	"./bg/mosaic/pattern-circles": 95,
	"./bg/mosaic/pattern-circles-bigger": 96,
	"./bg/mosaic/pattern-circles-bigger.svg": 96,
	"./bg/mosaic/pattern-circles.svg": 95,
	"./bg/mosaic/pattern-daisy": 97,
	"./bg/mosaic/pattern-daisy-pink": 98,
	"./bg/mosaic/pattern-daisy-pink.svg": 98,
	"./bg/mosaic/pattern-daisy.svg": 97,
	"./bg/mosaic/pattern-flowers": 99,
	"./bg/mosaic/pattern-flowers.svg": 99,
	"./bg/mosaic/pattern-hexagon": 100,
	"./bg/mosaic/pattern-hexagon.svg": 100,
	"./bg/mosaic/pattern-hills": 101,
	"./bg/mosaic/pattern-hills.svg": 101,
	"./bg/mosaic/pattern-husk": 102,
	"./bg/mosaic/pattern-husk-blue": 103,
	"./bg/mosaic/pattern-husk-blue.svg": 103,
	"./bg/mosaic/pattern-husk-saphire": 104,
	"./bg/mosaic/pattern-husk-saphire.svg": 104,
	"./bg/mosaic/pattern-husk.svg": 102,
	"./bg/mosaic/pattern-triangles": 105,
	"./bg/mosaic/pattern-triangles-red": 106,
	"./bg/mosaic/pattern-triangles-red.svg": 106,
	"./bg/mosaic/pattern-triangles.svg": 105,
	"./bg/mosaic/pattern-wave": 107,
	"./bg/mosaic/pattern-wave.svg": 107,
	"./bg/mosaic/pattern-zigzag": 108,
	"./bg/mosaic/pattern-zigzag-light-blue": 109,
	"./bg/mosaic/pattern-zigzag-light-blue.svg": 109,
	"./bg/mosaic/pattern-zigzag.svg": 108,
	"./bg/mosaic/performance": 110,
	"./bg/mosaic/performance.jpg": 110,
	"./bg/mosaic/sakura": 111,
	"./bg/mosaic/sakura.svg": 111,
	"./bg/mosaic/sencha": 112,
	"./bg/mosaic/sencha.jpg": 112,
	"./bg/mosaic/shodo": 113,
	"./bg/mosaic/shodo-lesson": 114,
	"./bg/mosaic/shodo-lesson.jpg": 114,
	"./bg/mosaic/shodo.jpg": 113,
	"./bg/mosaic/sun": 115,
	"./bg/mosaic/sun.svg": 115,
	"./bg/mosaic/team": 116,
	"./bg/mosaic/team.jpg": 116,
	"./bg/mosaic/temple": 117,
	"./bg/mosaic/temple.svg": 117,
	"./bg/mosaic/workshops": 118,
	"./bg/mosaic/workshops.jpg": 118,
	"./bg/pattern": 119,
	"./bg/pattern.svg": 119,
	"./bg/patterns/activities/1": 120,
	"./bg/patterns/activities/1.svg": 120,
	"./bg/patterns/activities/2": 121,
	"./bg/patterns/activities/2.svg": 121,
	"./bg/patterns/activities/3": 122,
	"./bg/patterns/activities/3.svg": 122,
	"./bg/patterns/activities/4": 123,
	"./bg/patterns/activities/4.svg": 123,
	"./bg/patterns/activities/5": 124,
	"./bg/patterns/activities/5.svg": 124,
	"./bg/patterns/blog": 125,
	"./bg/patterns/blog.svg": 125,
	"./bg/patterns/chessboard": 126,
	"./bg/patterns/chessboard.svg": 126,
	"./bg/patterns/clouds": 127,
	"./bg/patterns/clouds.svg": 127,
	"./bg/patterns/ellipse": 128,
	"./bg/patterns/ellipse.svg": 128,
	"./bg/patterns/husk": 129,
	"./bg/patterns/husk.svg": 129,
	"./bg/patterns/materials": 130,
	"./bg/patterns/materials.svg": 130,
	"./bg/patterns/mosaic": 131,
	"./bg/patterns/mosaic.svg": 131,
	"./bg/patterns/pixels": 132,
	"./bg/patterns/pixels.svg": 132,
	"./bg/patterns/shape-blue": 133,
	"./bg/patterns/shape-blue.svg": 133,
	"./bg/patterns/squares": 134,
	"./bg/patterns/squares.svg": 134,
	"./bg/patterns/triangles": 135,
	"./bg/patterns/triangles-light": 136,
	"./bg/patterns/triangles-light.svg": 136,
	"./bg/patterns/triangles.svg": 135,
	"./bg/shapes/circle": 137,
	"./bg/shapes/circle.svg": 137,
	"./bg/shapes/cloud-1": 138,
	"./bg/shapes/cloud-1.svg": 138,
	"./bg/shapes/cloud-2": 139,
	"./bg/shapes/cloud-2.svg": 139,
	"./bg/shapes/cloud-blue": 140,
	"./bg/shapes/cloud-blue.svg": 140,
	"./bg/shapes/cloud-lightblue": 141,
	"./bg/shapes/cloud-lightblue.svg": 141,
	"./bg/shapes/cloud-red": 142,
	"./bg/shapes/cloud-red.svg": 142,
	"./bg/shapes/cube": 143,
	"./bg/shapes/cube.svg": 143,
	"./bg/shapes/ecru/1": 144,
	"./bg/shapes/ecru/1.svg": 144,
	"./bg/shapes/ecru/2": 145,
	"./bg/shapes/ecru/2.svg": 145,
	"./bg/shapes/ecru/3": 146,
	"./bg/shapes/ecru/3.svg": 146,
	"./bg/shapes/ecru/4": 147,
	"./bg/shapes/ecru/4.svg": 147,
	"./bg/shapes/gallery/activities": 148,
	"./bg/shapes/gallery/activities.svg": 148,
	"./bg/shapes/gallery/party": 149,
	"./bg/shapes/gallery/party.svg": 149,
	"./bg/shapes/gallery/trips": 150,
	"./bg/shapes/gallery/trips.svg": 150,
	"./bg/shapes/husk": 151,
	"./bg/shapes/husk.svg": 151,
	"./bg/shapes/triangles": 152,
	"./bg/shapes/triangles.svg": 152,
	"./icons/check": 153,
	"./icons/check-green": 154,
	"./icons/check-green.svg": 154,
	"./icons/check-light": 155,
	"./icons/check-light.svg": 155,
	"./icons/check-white": 156,
	"./icons/check-white.svg": 156,
	"./icons/check.svg": 153,
	"./icons/close": 157,
	"./icons/close.svg": 157,
	"./icons/cookies": 158,
	"./icons/cookies.svg": 158,
	"./icons/cross": 159,
	"./icons/cross.svg": 159,
	"./icons/dot": 160,
	"./icons/dot.svg": 160,
	"./icons/enroll": 161,
	"./icons/enroll.svg": 161,
	"./icons/envelope": 162,
	"./icons/envelope.svg": 162,
	"./icons/facebook": 163,
	"./icons/facebook-w": 164,
	"./icons/facebook-w.svg": 164,
	"./icons/facebook.svg": 163,
	"./icons/fb": 165,
	"./icons/fb.svg": 165,
	"./icons/flag-en": 166,
	"./icons/flag-en.svg": 166,
	"./icons/flag-jp": 167,
	"./icons/flag-jp.svg": 167,
	"./icons/flag-pl": 168,
	"./icons/flag-pl.svg": 168,
	"./icons/gift": 169,
	"./icons/gift.svg": 169,
	"./icons/instagram": 170,
	"./icons/instagram-w": 171,
	"./icons/instagram-w.svg": 171,
	"./icons/instagram.svg": 170,
	"./icons/keyboard": 172,
	"./icons/keyboard.svg": 172,
	"./icons/linkedin": 173,
	"./icons/linkedin.svg": 173,
	"./icons/marker": 2,
	"./icons/marker.png": 2,
	"./icons/marker.svg": 308,
	"./icons/mobile": 174,
	"./icons/mobile.svg": 174,
	"./icons/price": 175,
	"./icons/price-blue": 176,
	"./icons/price-blue.svg": 176,
	"./icons/price-green": 177,
	"./icons/price-green.svg": 177,
	"./icons/price-pink": 178,
	"./icons/price-pink.svg": 178,
	"./icons/price.svg": 175,
	"./icons/quote": 179,
	"./icons/quote-big": 180,
	"./icons/quote-big.svg": 180,
	"./icons/quote.svg": 179,
	"./icons/star-1-blue": 181,
	"./icons/star-1-blue.svg": 181,
	"./icons/star-1-red": 182,
	"./icons/star-1-red.svg": 182,
	"./icons/star-3-blue": 183,
	"./icons/star-3-blue.svg": 183,
	"./icons/star-3-red": 184,
	"./icons/star-3-red.svg": 184,
	"./icons/tag-blue": 185,
	"./icons/tag-blue.svg": 185,
	"./icons/tag-red": 186,
	"./icons/tag-red.svg": 186,
	"./icons/twitter": 187,
	"./icons/twitter.svg": 187,
	"./icons/youtube": 188,
	"./icons/youtube.svg": 188,
	"./icons/zoom": 189,
	"./icons/zoom.svg": 189,
	"./logo": 190,
	"./logo-mobile": 191,
	"./logo-mobile.svg": 191,
	"./logo.svg": 190,
	"./pic/activities/sakaki": 192,
	"./pic/activities/sakaki.png": 192,
	"./pic/activities/shizuoka": 193,
	"./pic/activities/shizuoka.png": 193,
	"./pic/activities/tokio": 194,
	"./pic/activities/tokio.png": 194,
	"./pic/advantage": 195,
	"./pic/advantage-mobile": 196,
	"./pic/advantage-mobile.png": 196,
	"./pic/advantage.png": 195,
	"./pic/authors/agata-krukowska": 197,
	"./pic/authors/agata-krukowska.png": 197,
	"./pic/authors/marta-klimiuk": 198,
	"./pic/authors/marta-klimiuk.png": 198,
	"./pic/authors/monika-zachaj": 199,
	"./pic/authors/monika-zachaj.png": 199,
	"./pic/blank/226x183": 200,
	"./pic/blank/226x183.jpg": 200,
	"./pic/bunkasai": 201,
	"./pic/bunkasai.jpg": 201,
	"./pic/compare/after": 202,
	"./pic/compare/after.jpg": 202,
	"./pic/compare/before": 203,
	"./pic/compare/before.jpg": 203,
	"./pic/compare/old/after": 204,
	"./pic/compare/old/after.jpg": 204,
	"./pic/compare/old/before": 205,
	"./pic/compare/old/before.jpg": 205,
	"./pic/contact": 206,
	"./pic/contact.svg": 206,
	"./pic/courses/00": 207,
	"./pic/courses/00.svg": 207,
	"./pic/courses/01": 208,
	"./pic/courses/01.svg": 208,
	"./pic/courses/02": 209,
	"./pic/courses/02.svg": 209,
	"./pic/courses/advanced-level": 210,
	"./pic/courses/advanced-level.png": 210,
	"./pic/courses/beginner-level": 211,
	"./pic/courses/beginner-level.png": 211,
	"./pic/courses/benefit01": 212,
	"./pic/courses/benefit01.svg": 212,
	"./pic/courses/benefit02": 213,
	"./pic/courses/benefit02.svg": 213,
	"./pic/courses/benefit03": 214,
	"./pic/courses/benefit03.svg": 214,
	"./pic/courses/benefit04": 215,
	"./pic/courses/benefit04.svg": 215,
	"./pic/courses/benefit05": 216,
	"./pic/courses/benefit05.svg": 216,
	"./pic/courses/benefit06": 217,
	"./pic/courses/benefit06.svg": 217,
	"./pic/courses/benefit07": 218,
	"./pic/courses/benefit07.svg": 218,
	"./pic/courses/benefit08": 219,
	"./pic/courses/benefit08.svg": 219,
	"./pic/courses/intermediate-level": 220,
	"./pic/courses/intermediate-level.png": 220,
	"./pic/courses/monika-zachaj": 221,
	"./pic/courses/monika-zachaj.png": 221,
	"./pic/courses/pakiet-startowy": 222,
	"./pic/courses/pakiet-startowy.png": 222,
	"./pic/courses/ryotaro-sakamoto": 223,
	"./pic/courses/ryotaro-sakamoto.png": 223,
	"./pic/gallery/2017/japan-bowl-turniej-o-puchar-japonii": 224,
	"./pic/gallery/2017/japan-bowl-turniej-o-puchar-japonii.jpg": 224,
	"./pic/gallery/2017/matsuri-piknik-z-kultura-japonii": 225,
	"./pic/gallery/2017/matsuri-piknik-z-kultura-japonii.jpg": 225,
	"./pic/gallery/2018/japan-bowl-turniej-o-puchar-japonii": 226,
	"./pic/gallery/2018/japan-bowl-turniej-o-puchar-japonii.jpg": 226,
	"./pic/gallery/2018/szkola-letnia": 227,
	"./pic/gallery/2018/szkola-letnia.jpg": 227,
	"./pic/gallery/2018/warsztaty-chust-furoshiki": 228,
	"./pic/gallery/2018/warsztaty-chust-furoshiki.jpg": 228,
	"./pic/gallery/2018/warsztaty-ehomaki": 229,
	"./pic/gallery/2018/warsztaty-ehomaki.jpg": 229,
	"./pic/gallery/2018/warsztaty-herbaty-sencha": 230,
	"./pic/gallery/2018/warsztaty-herbaty-sencha.jpg": 230,
	"./pic/gallery/2018/warsztaty-kawaii-sushi": 231,
	"./pic/gallery/2018/warsztaty-kawaii-sushi.jpg": 231,
	"./pic/gallery/2019/impreza-bonenkai": 232,
	"./pic/gallery/2019/impreza-bonenkai.jpg": 232,
	"./pic/gallery/2019/matsuri-piknik-z-kultura-japonii": 233,
	"./pic/gallery/2019/matsuri-piknik-z-kultura-japonii.jpg": 233,
	"./pic/gallery/2019/szkola-letnia": 234,
	"./pic/gallery/2019/szkola-letnia.jpg": 234,
	"./pic/gallery/2019/warsztaty-obento": 235,
	"./pic/gallery/2019/warsztaty-obento.jpg": 235,
	"./pic/gallery/2019/warsztaty-slodyczy-wagashi": 236,
	"./pic/gallery/2019/warsztaty-slodyczy-wagashi.jpg": 236,
	"./pic/gallery/2020/ceremonia-herbaty": 237,
	"./pic/gallery/2020/ceremonia-herbaty.jpg": 237,
	"./pic/godzilla": 0,
	"./pic/godzilla-mobile": 3,
	"./pic/godzilla-mobile.png": 3,
	"./pic/godzilla-mobile.webp": 309,
	"./pic/godzilla.png": 0,
	"./pic/godzilla.svg": 310,
	"./pic/godzilla.webp": 311,
	"./pic/godzilla/beast": 238,
	"./pic/godzilla/beast.png": 238,
	"./pic/godzilla/pattern": 239,
	"./pic/godzilla/pattern.svg": 239,
	"./pic/google-rating": 240,
	"./pic/google-rating.svg": 240,
	"./pic/hero/all": 241,
	"./pic/hero/all.png": 241,
	"./pic/hero/clouds": 4,
	"./pic/hero/clouds.png": 4,
	"./pic/hero/clouds.webp": 312,
	"./pic/hero/desc": 242,
	"./pic/hero/desc.svg": 242,
	"./pic/hero/land": 5,
	"./pic/hero/land.png": 5,
	"./pic/hero/land.webp": 313,
	"./pic/hero/mobile": 6,
	"./pic/hero/mobile.jpg": 6,
	"./pic/hero/mobile.webp": 314,
	"./pic/hero/mountain": 7,
	"./pic/hero/mountain.png": 7,
	"./pic/hero/mountain.webp": 315,
	"./pic/hero/sea": 8,
	"./pic/hero/sea.png": 8,
	"./pic/hero/sea.webp": 316,
	"./pic/hero/sun": 9,
	"./pic/hero/sun.png": 9,
	"./pic/hero/sun.webp": 317,
	"./pic/hero/trees": 10,
	"./pic/hero/trees.png": 10,
	"./pic/hero/trees.webp": 318,
	"./pic/hero/video-bottom": 243,
	"./pic/hero/video-bottom.svg": 243,
	"./pic/hero/video-top": 244,
	"./pic/hero/video-top.svg": 244,
	"./pic/hero/waves": 11,
	"./pic/hero/waves.png": 11,
	"./pic/hero/waves.webp": 319,
	"./pic/home/1": 245,
	"./pic/home/1.svg": 245,
	"./pic/home/all": 246,
	"./pic/home/all.png": 246,
	"./pic/home/owners": 12,
	"./pic/home/owners.png": 12,
	"./pic/home/owners.svg": 320,
	"./pic/keyboard": 247,
	"./pic/keyboard.svg": 247,
	"./pic/kitty-group": 248,
	"./pic/kitty-group-light": 249,
	"./pic/kitty-group-light.png": 249,
	"./pic/kitty-group.png": 248,
	"./pic/kitty-individual": 250,
	"./pic/kitty-individual.png": 250,
	"./pic/labels/a1_1": 251,
	"./pic/labels/a1_1.png": 251,
	"./pic/labels/a1_1b": 252,
	"./pic/labels/a1_1b.png": 252,
	"./pic/labels/a1_2": 253,
	"./pic/labels/a1_2.png": 253,
	"./pic/labels/a1_2a": 254,
	"./pic/labels/a1_2a.png": 254,
	"./pic/labels/a2_1": 255,
	"./pic/labels/a2_1.png": 255,
	"./pic/labels/a2_1b": 256,
	"./pic/labels/a2_1b.png": 256,
	"./pic/labels/a2_2": 257,
	"./pic/labels/a2_2.png": 257,
	"./pic/labels/a2_2a": 258,
	"./pic/labels/a2_2a.png": 258,
	"./pic/labels/a2_2b": 259,
	"./pic/labels/a2_2b.png": 259,
	"./pic/labels/b1_1": 260,
	"./pic/labels/b1_1.png": 260,
	"./pic/labels/b1_1b": 261,
	"./pic/labels/b1_1b.png": 261,
	"./pic/labels/b1_2": 262,
	"./pic/labels/b1_2.png": 262,
	"./pic/labels/b2_1": 263,
	"./pic/labels/b2_1.png": 263,
	"./pic/labels/b2_2": 264,
	"./pic/labels/b2_2.png": 264,
	"./pic/labels/c1_1": 265,
	"./pic/labels/c1_1.png": 265,
	"./pic/labels/c1_2": 266,
	"./pic/labels/c1_2.png": 266,
	"./pic/labels/c2_2": 267,
	"./pic/labels/c2_2.png": 267,
	"./pic/labels/materials/doki-doki-1": 268,
	"./pic/labels/materials/doki-doki-1.jpg": 268,
	"./pic/labels/materials/doki-doki-2": 269,
	"./pic/labels/materials/doki-doki-2.jpg": 269,
	"./pic/labels/materials/doki-doki-3": 270,
	"./pic/labels/materials/doki-doki-3.jpg": 270,
	"./pic/labels/materials/pera-pera-1": 271,
	"./pic/labels/materials/pera-pera-1.jpg": 271,
	"./pic/labels/materials/pera-pera-2": 272,
	"./pic/labels/materials/pera-pera-2.jpg": 272,
	"./pic/labels/materials/pera-pera-3": 273,
	"./pic/labels/materials/pera-pera-3.jpg": 273,
	"./pic/labels/materials/waku-waku-1": 274,
	"./pic/labels/materials/waku-waku-1.jpg": 274,
	"./pic/labels/materials/waku-waku-2": 275,
	"./pic/labels/materials/waku-waku-2.jpg": 275,
	"./pic/labels/materials/waku-waku-3": 276,
	"./pic/labels/materials/waku-waku-3.jpg": 276,
	"./pic/magazine": 277,
	"./pic/magazine.png": 277,
	"./pic/materials/100-lecie-przyjazni": 278,
	"./pic/materials/100-lecie-przyjazni.png": 278,
	"./pic/materials/hiragana": 279,
	"./pic/materials/hiragana.png": 279,
	"./pic/materials/katakana": 280,
	"./pic/materials/katakana.png": 280,
	"./pic/news-main": 281,
	"./pic/news-main.jpg": 281,
	"./pic/newsletter": 13,
	"./pic/newsletter.png": 13,
	"./pic/newsletter.svg": 321,
	"./pic/owners": 14,
	"./pic/owners.png": 14,
	"./pic/owners.webp": 322,
	"./pic/ramen1": 15,
	"./pic/ramen1.png": 15,
	"./pic/ramen1.svg": 323,
	"./pic/teachers/agata-krukowska": 16,
	"./pic/teachers/agata-krukowska.png": 16,
	"./pic/teachers/agata-krukowska.webp": 324,
	"./pic/teachers/alicja-suska": 17,
	"./pic/teachers/alicja-suska.png": 17,
	"./pic/teachers/alicja-suska.webp": 325,
	"./pic/teachers/animation": 282,
	"./pic/teachers/animation-image": 283,
	"./pic/teachers/animation-image.jpg": 283,
	"./pic/teachers/animation.svg": 282,
	"./pic/teachers/hiroko-fujii": 18,
	"./pic/teachers/hiroko-fujii.png": 18,
	"./pic/teachers/hiroko-fujii.webp": 326,
	"./pic/teachers/julia-caba": 19,
	"./pic/teachers/julia-caba.png": 19,
	"./pic/teachers/julia-caba.webp": 327,
	"./pic/teachers/katarzyna-stanko": 20,
	"./pic/teachers/katarzyna-stanko.png": 20,
	"./pic/teachers/katarzyna-stanko.webp": 328,
	"./pic/teachers/krzysztof-walaszek": 21,
	"./pic/teachers/krzysztof-walaszek.png": 21,
	"./pic/teachers/krzysztof-walaszek.webp": 329,
	"./pic/teachers/magdalena-kisly": 22,
	"./pic/teachers/magdalena-kisly.png": 22,
	"./pic/teachers/magdalena-kisly.webp": 330,
	"./pic/teachers/marin-iwai": 23,
	"./pic/teachers/marin-iwai.png": 23,
	"./pic/teachers/marin-iwai.webp": 331,
	"./pic/teachers/marta-klimiuk-nikkarinen": 24,
	"./pic/teachers/marta-klimiuk-nikkarinen.png": 24,
	"./pic/teachers/marta-klimiuk-nikkarinen.webp": 332,
	"./pic/teachers/miho-takahashi": 25,
	"./pic/teachers/miho-takahashi.png": 25,
	"./pic/teachers/miho-takahashi.webp": 333,
	"./pic/teachers/monika-zachaj": 26,
	"./pic/teachers/monika-zachaj.png": 26,
	"./pic/teachers/monika-zachaj.webp": 334,
	"./pic/teachers/owner": 284,
	"./pic/teachers/owner.png": 284,
	"./pic/teachers/ryotaro-sakamoto": 27,
	"./pic/teachers/ryotaro-sakamoto.png": 27,
	"./pic/teachers/ryotaro-sakamoto.webp": 335,
	"./pic/teachers/urszula-hellich": 28,
	"./pic/teachers/urszula-hellich.png": 28,
	"./pic/teachers/urszula-hellich.webp": 336,
	"./pic/teachers/weronika-smorag": 29,
	"./pic/teachers/weronika-smorag.png": 29,
	"./pic/teachers/weronika-smorag.webp": 337,
	"./pic/teachers/wiktoria-piontek": 30,
	"./pic/teachers/wiktoria-piontek.png": 30,
	"./pic/teachers/wiktoria-piontek.webp": 338,
	"./pic/team": 285,
	"./pic/team.jpg": 285,
	"./pic/testimonials/blank": 31,
	"./pic/testimonials/blank.jpg": 31,
	"./pic/testimonials/blank.webp": 339,
	"./pic/testimonials/gabrysia": 32,
	"./pic/testimonials/gabrysia.jpg": 32,
	"./pic/testimonials/gabrysia.webp": 340,
	"./pic/testimonials/klaudia": 33,
	"./pic/testimonials/klaudia.jpg": 33,
	"./pic/testimonials/klaudia.webp": 341,
	"./pic/testimonials/kuba": 34,
	"./pic/testimonials/kuba.jpg": 34,
	"./pic/testimonials/kuba.webp": 342,
	"./pic/testimonials/monika": 35,
	"./pic/testimonials/monika.jpg": 35,
	"./pic/testimonials/monika.webp": 343,
	"./pic/testimonials/naza": 36,
	"./pic/testimonials/naza.jpg": 36,
	"./pic/testimonials/naza.webp": 344,
	"./pic/testimonials/patti": 37,
	"./pic/testimonials/patti.jpg": 37,
	"./pic/testimonials/patti.webp": 345,
	"./pic/testimonials/wiktoria": 38,
	"./pic/testimonials/wiktoria.jpg": 38,
	"./pic/testimonials/wiktoria.webp": 346,
	"./pic/timeline": 286,
	"./pic/timeline.jpg": 286,
	"./pic/timeline/2011": 287,
	"./pic/timeline/2011.jpg": 287,
	"./pic/timeline/2013": 288,
	"./pic/timeline/2013.jpg": 288,
	"./pic/timeline/2014": 289,
	"./pic/timeline/2014.jpg": 289,
	"./pic/timeline/2016": 290,
	"./pic/timeline/2016.jpg": 290,
	"./pic/timeline/2017": 291,
	"./pic/timeline/2017.jpg": 291,
	"./pic/timeline/2018": 292,
	"./pic/timeline/2018.jpg": 292,
	"./pic/timeline/2019": 293,
	"./pic/timeline/2019.jpg": 293,
	"./pic/timeline/2020": 294,
	"./pic/timeline/2020.jpg": 294,
	"./pic/timeline/2021": 295,
	"./pic/timeline/2021.jpg": 295,
	"./pic/timeline/2022": 296,
	"./pic/timeline/2022.jpg": 296,
	"./pic/timeline/2023": 297,
	"./pic/timeline/2023.jpg": 297,
	"./pic/timeline/2024": 298,
	"./pic/timeline/2024.jpg": 298,
	"./pic/tree": 39,
	"./pic/tree.png": 39,
	"./pic/tree.webp": 347,
	"./pic/umbrella": 299,
	"./pic/umbrella.jpg": 299,
	"./pic/warsaw-card": 300,
	"./pic/warsaw-card.jpg": 300,
	"./pic/wave": 301,
	"./pic/wave.png": 301,
	"./pic/wsjj-team": 302,
	"./pic/wsjj-team-mobile": 303,
	"./pic/wsjj-team-mobile.webp": 303,
	"./pic/wsjj-team.webp": 302
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 306;